<template>
  <!-- 案件詳細 -->
  <div id="KenshinRequestAcceptDetail">
    <div id="container">
      <div class="labelTitle lable">企業検診 川越受付</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td><a @click="isShowDetail = true">{{data.receiptNumber}} <b-icon icon="vector-arrange-above"/></a></td>
            </tr>
            <tr>
              <th>申込日</th>
              <td>{{data.applicationDate}}</td>
            </tr>
            <tr>
              <th>出荷希望週</th>
              <td>{{data.shippingDate}} ～ 
                <a @click="shippingCalenderActive = true"><b-icon icon="calendar-month"></b-icon></a>
              </td>
            </tr>
            <tr>
              <th>出荷予定日<span class="require"/></th>
              <td><input id="expectedShippingDate" style="width:100px;" type="text" v-model="data.expectedShippingDate" disabled placeholder="年/月/日"/><a @click="stockCalenderActive = true"><b-icon icon="calendar-cursor"></b-icon></a></td>
            </tr>
            <tr>
              <th>検査種別</th>
              <td>{{getChoiceName(data.inspectionKind,inspectionKindList)}}<span v-if="data.demo" class="demo"/></td>
            </tr>
            <tr>
              <th>機種</th>
              <td>{{getChoiceName(data.model,kenshinDeviceList)}}</td>
            </tr>
            <tr>
              <th>台数</th>
              <td>{{data.units}}</td>
            </tr>
            <tr>
              <th>企業名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.companyName}}</td>
            </tr>
            <tr>
              <th>依頼元</th>
              <td>{{data.client}}<span v-if="data.proxyFlag" class="agent"/></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">検診情報備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.kenshinNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">検診グループ受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.gReceptionNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">備考</th>
              <td><textarea maxlength="256" style="resize:vertical;max-width:100%;height:100px;" v-model="data.note"></textarea></td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" icon-left="stamper" @click="receptionist">受付</b-button>
          <b-button class="is-primary" icon-left="calendar-range" @click="shipmentDateAdjustment">出荷日調整</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <floatingDiv v-if="isShowDetail" @close="closeDetail" title="" width="900px" height="480px" top="100px" right="100px">
      <kenshinRequestDetail v-bind:data="data.applicationDetails" v-bind:isAccommodations="isAccommodations"/>
    </floatingDiv>
    <floatingDiv v-if="shippingCalenderActive" @close="closeShippingCalender" title="" width="1250px" height="800px" top="100px" right="100px">
        <shippingCalenderModal style="width:600px;"></shippingCalenderModal>
    </floatingDiv>
    <b-modal :active.sync="stockCalenderActive" has-modal-card>
      <stockCalenderModal :deviceKind="data.model" :count="data.units" @select="setShippingDate"></stockCalenderModal>
    </b-modal>
    
  </div>
</template>

<script>
import floatingDiv from "@/components/mock/common/FloatingDiv";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import ShippingCalenderModal from "@/components/mock/philips/calender/ShippingCalender";
import StockCalenderModal from "@/components/mock/philips/kenshin/stock/StockCalender";
import {choicesType} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";

export default {
  name: "KenshinRequestAcceptDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "KenshinRequestAccept",
        params: { searchConditions: this.searchParams },
      });
    },
    receptionist: function() {
      var element = document.getElementById("expectedShippingDate");
      element.style["border-color"] = "";
      if(!this.data.expectedShippingDate){
        element.style["border-color"] = "red";
        this.showErrorMessage("出荷予定日は必須項目です。")
        return;
      }
      var excuteApi = this.setKenshinKawagoeReceptionPOST;
      var successCallBack = this.setKenshinKawagoeReceptionPOSTSuccess;
      var errorCallBack = this.setKenshinKawagoeReceptionPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinKawagoeReceptionPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      delete obj.applicationDetails
      delete obj.mailInfo
      return client.apis.internalKenshin.setKenshinKawagoeReceptionPOST({
        body:obj
      });
    },
    setKenshinKawagoeReceptionPOSTSuccess: function(result) {
      this.showSuccess(result,this.back())
    },
    setKenshinKawagoeReceptionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    shipmentDateAdjustment: function() {
      var subject = encodeURI("【Philips Care Portal】 企業検診 出荷日のご調整について")
      var body = encodeURI(this.data.mailInfo.client+"\n\n<ここに本文を記載してください。>\n\n【お申込内容】\n[受付番号]："+this.data.mailInfo.receiptNumber+"\n[申込み種別]：企業検診（申込み）\n[発注元企業名]："+this.data.mailInfo.companyName+"\n[検査種類]："+this.data.mailInfo.inspectionKind+"\n[希望出荷週]："+this.data.mailInfo.shippingDate+"\n[台数]："+this.data.mailInfo.units+"\n\n\n株式会社フィリップス・ジャパン\n\n"
      )
      const link = document.createElement("a")
      link.href = "mailto:"+ this.data.mailInfo.mail + "?subject=" + subject + "&body=" + body;
      link.click()
    },
    closeDetail: function(){
      this.isShowDetail = false;
    },
    closeShippingCalender: function(){
      this.shippingCalenderActive = false;
    },
    setShippingDate: function(date){
      this.data.expectedShippingDate = this.yyyy_sla_MM_sla_dd(date);
      this.stockCalenderActive = false;
    },
    getChoiceName: function(val,list) {
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    doSearch: function() {
      var excuteApi = this.getKenshinKawagoeReceptionDetailPOST;
      var successCallBack = this.getKenshinKawagoeReceptionDetailPOSTSuccess;
      var errorCallBack = this.getKenshinKawagoeReceptionDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinKawagoeReceptionDetailPOST: function(client) {
      return client.apis.internalKenshin.getKenshinKawagoeReceptionDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getKenshinKawagoeReceptionDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getKenshinKawagoeReceptionDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId =  userInfo.roleId;
    var targetNumber = decodeURIComponent(this.$route.query["receiptNumber"]);
    var searchParams = this.$route.params["searchConditions"];
    let inspectionKindList = this.getChoiceList(choicesType.kenshinKind, false);
    inspectionKindList.unshift({})
    let kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    kenshinDeviceList.unshift({})
    return {
      targetNumber,
      searchParams,
      inspectionKindList,
      kenshinDeviceList,
      data: {},
      shippingCalenderActive: false,
      stockCalenderActive: false,
      isShowDetail: false,
      isAccommodations: roleId == role.role_accommodations
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.doSearch();
  },
  filters: {},
  components: { 
    floatingDiv: floatingDiv,
    shippingCalenderModal: ShippingCalenderModal,
    kenshinRequestDetail:KenshinRequestDetail,
    stockCalenderModal: StockCalenderModal
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinRequestAcceptDetail.vue